<template>
    <router-view :key="$route.name"></router-view>
</template>

<script>

export default {
    name: 'App',
}
</script>

<style>

</style>
